var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-pwd-reset" }, [
    _c(
      "form",
      {
        ref: "loginForm",
        attrs: { id: "login-form-" + _vm._uid, method: "post" }
      },
      [
        _c("div", { class: { "modal-body": _vm.modalElement } }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                {
                  staticClass: "input-unit",
                  attrs: { "data-validate": "mail" }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.username,
                        expression: "username"
                      }
                    ],
                    attrs: {
                      "data-testing": "email-login",
                      type: "email",
                      name: "email",
                      autocomplete: "email",
                      id: "email" + _vm._uid,
                      "data-autofocus": ""
                    },
                    domProps: { value: _vm.username },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.username = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "email" + _vm._uid } }, [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.loginEmail")) + "*"
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "error-msg" }, [
                _vm._v(
                  _vm._s(
                    _vm.$translate("Ceres::Template.loginEnterConfirmEmail")
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                {
                  staticClass: "input-unit",
                  class: { "no-bottom": _vm.modalElement },
                  attrs: { "data-validate": "text" }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password"
                      }
                    ],
                    attrs: {
                      "data-testing": "password-login",
                      type: "password",
                      name: "password",
                      autocomplete: "current-password",
                      id: "password" + _vm._uid
                    },
                    domProps: { value: _vm.password },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.password = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "password" + _vm._uid } }, [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.loginPassword")) +
                        "*"
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "error-msg" }, [
                _vm._v(
                  _vm._s(_vm.$translate("Ceres::Template.loginEmptyPassword"))
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            class: {
              "modal-footer justify-content-between": _vm.modalElement,
              row: !_vm.modalElement
            }
          },
          [
            _c("div", { class: { "col-7 col-sm-4": !_vm.modalElement } }, [
              _c(
                "a",
                {
                  staticClass: "small text-appearance",
                  attrs: { href: "javascript:void(0)" },
                  on: { click: _vm.showResetPwdView }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$translate("Ceres::Template.loginForgotPassword")
                    ) + "?"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { class: { "col-5 col-sm-8 text-sm-right": !_vm.modalElement } },
              [
                _vm._t("extend-overlay-buttons"),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-appearance btn-medium",
                    class: [
                      { "float-right": !_vm.modalElement },
                      _vm.buttonSizeClass
                    ],
                    attrs: {
                      "data-testing": "submit-login",
                      disabled: _vm.isDisabled
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.validateLogin($event)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$translate("Ceres::Template.login")) +
                        "\n                    "
                    ),
                    _c("icon", {
                      attrs: { icon: "user", loading: _vm.isDisabled }
                    })
                  ],
                  1
                )
              ],
              2
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }